export default __webpack_public_path__ + "static/media/Rock_Texture.5692d5b7.png";